import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CommonModal from '@/components-latest/shared/Modals/CommonModal'
import Button from '@/components-latest/primitives/Button'
import Text from '@/components-latest/primitives/Text'
import Styles from '../OnlineRestriction.module.scss'
import Restriction from '@/components-latest/primitives/Icons/Restriction'

interface AutomaticOnlineRestrictionProps {
  children?: React.ReactNode
  onClose: () => void
  isOpen: boolean
}

const AutomaticOnlineRestriction: React.FC<AutomaticOnlineRestrictionProps> = ({
  children,
  onClose,
  isOpen
}) => {
  const { t } = useTranslation()

  return (
    <>
      <CommonModal
        scrollableBody={false}
        className={Styles.modal}
        bodyClass={Styles.body}
        body={
          <div className={Styles.message}>
            <Restriction />
            <Text variant="title-3" gutter={8} className={Styles.title}>
              {t('store-temporarily-closed.title')}
            </Text>
            <Text variant="subtitle" className={Styles.dimmed}>
              {t('store-temporarily-closed.message')}
            </Text>
          </div>
        }
        footer={
          <Button
            variant="branded"
            size="small"
            onClick={onClose}
            className={Styles.button}>
            {t('store-temporarily-closed.button')}
          </Button>
        }
        open={isOpen}
        title=""
        onOpenChange={open => {
          if (!open) onClose()
        }}>
        {children}
      </CommonModal>
    </>
  )
}

export default AutomaticOnlineRestriction
